<app-login-container>
	@if (userProfile) {
		<div>
			@if (displayStep === 'selectMethod') {
				<div>
					<h1 class="row-center text-main-color margin-top-16px" i18n="@@loginMfa-2faHeader">
						Two-Factor Authentication
					</h1>
					<div
						class="row-center shorter-width subtext-color"
						i18n="@@loginMfa-2faDescription"
						style="text-align: center"
					>
						Two-factor authentication is required in order to sign in to your account.
					</div>
					<div
						class="row-center text-secondary-blue font-web-body-3 font-weight-body-2"
						i18n="@@loginMfa-2faVerificationMethod"
						style="text-align: center; margin: 1.5em 0"
					>
						Choose verification method
					</div>
					<div class="row-center" style="margin-top: 1em">
						<mat-button-toggle-group
							class="no-border"
							style="width: 80%; margin-bottom: 1em"
							[hideSingleSelectionIndicator]="true"
						>
							<mat-button-toggle
								class="toggleButton"
								style="width: 100%"
								[checked]="emailChecked"
								(click)="selectEmailButton()"
								data-automation-id="select-email-toggle"
							>
								<div class="flex-row">
									<span class="label" i18n="@@loginMfa-emailLabel">Email:</span>
									<span class="value text-box">{{ userProfile.user.email }}</span>
								</div>
							</mat-button-toggle>
						</mat-button-toggle-group>
						@if (!hideSms) {
							<mat-button-toggle-group class="no-border" style="width: 80%" [hideSingleSelectionIndicator]="true">
								<mat-button-toggle
									class="toggleButton"
									style="width: 100%"
									[checked]="mobileChecked"
									(click)="selectMobileButton()"
									data-automation-id="select-mobile-toggle"
								>
									<span class="label" style="float: left" i18n="@@loginMfa-mobileNumberLabel">Mobile Number:</span>
									<span class="value" style="float: right">{{ userProfile.user.phoneNumber | phoneNumber }}</span>
								</mat-button-toggle>
							</mat-button-toggle-group>
						}
					</div>
					<div class="row-center" style="margin-top: 5em">
						<button
							mat-flat-button
							type="submit"
							(click)="backToLoginClicked()"
							class="primary-button"
							i18n="Back button @@loginMfa-backButton"
							data-automation-id="login-mfa-back-button"
						>
							Back
						</button>
						<button
							mat-flat-button
							type="submit"
							[disabled]="getSelectedMfaType() === undefined"
							(click)="goToVerifyClicked()"
							class="primary-button"
							i18n="Next button @@loginMfa-nextButton"
							data-automation-id="login-mfa-next-button"
						>
							Next
						</button>
					</div>
				</div>
			}
			@if (displayStep === 'verifyToken') {
				<div>
					<h1 class="row-center margin-top-16px" i18n="@@loginMfa-2faHeader">Two-Factor Authentication</h1>
					@if (getSelectedMfaType() === 'sms') {
						<div class="row-center sent-to-message" i18n="@@loginMfa-verify2faDescription_phone">
							Code sent to {{ userProfile.user.phoneNumber | phoneNumber }}
						</div>
					}
					@if (getSelectedMfaType() === 'email') {
						<div class="row-center sent-to-message" i18n="@@loginMfa-verify2faDescription_email">
							Code sent to {{ userProfile.user.email }}
						</div>
					}
					<div class="row-center enter-code-message" i18n="@@loginMfa-verify2faEnterCode">
						Please enter the 6-digit verification code
					</div>
					<div class="row-center" style="margin-top: 1em">
						<form [formGroup]="formGroup">
							<mat-form-field subscriptSizing="dynamic" class="column-double" appearance="outline">
								<mat-label i18n="@@loginMfa-token">Verification Code</mat-label>
								<input
									appAutoFocus
									matInput
									formControlName="enteredTokenField"
									(ngModelChange)="enteredTokenChanged($event)"
									maxlength="6"
									autocomplete="off"
									data-automation-id="verification-code-input"
								/>
								@if (formGroup.controls.enteredTokenField.invalid) {
									<mat-error
										class="row-left"
										i18n="Invalid token @@loginMfa-invalidToken"
										data-automation-id="verification-code-error"
										>Invalid code, please try again.</mat-error
									>
								}
							</mat-form-field>
						</form>
					</div>
					<div class="row-center">
						<button
							mat-stroked-button
							class="secondary-button"
							(click)="requestToken()"
							i18n="@@loginMfa-resendCode"
							data-automation-id="login-mfa-resend-code-button"
						>
							Resend Code
						</button>
					</div>
					<div class="row-center" style="margin-top: 7em">
						<button
							mat-flat-button
							type="submit"
							(click)="backToSendTokenClicked()"
							class="primary-button"
							i18n="Back button @@loginMfa-backButton"
							data-automation-id="login-mfa-back-two-button"
						>
							Back
						</button>
						<button
							mat-flat-button
							type="submit"
							[disabled]="true"
							class="primary-button"
							i18n="Next button @@loginMfa-nextButton"
							data-automation-id="login-mfa-next-two-button"
						>
							Next
						</button>
					</div>
				</div>
			}
		</div>
	}
</app-login-container>
